export const LINKS = {
  HELP_CENTER: 'https://tm2.com/help-center/faq/',
  PRIVACY_POLICY:
    'https://f.hubspotusercontent10.net/hubfs/7856865/Documents/TM2%20-%20Privacy%20policy.pdf',
  RULEBOOK: 'https://tm2.market/rulebook',
  TERMS_AND_CONDITIONS: 'https://tm2.market/terms-of-use',
  TRANSFERS_OF_PERSONAL_DATA: 'https://tm2.market/article-49-explicit-consent-form',
  SUPPORT: 'https://tm2.com/help-center/support/',
};
